import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import EventBanner from '../../components/event-banner';

const EventsWrapper = styled.div`
  width: 950px;
  margin: auto;
  padding: 32px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 667px) {
    width: 100%;
    padding: 24px 16px;
    justify-content: center;
  }
`;

const StyledEventBanner = styled(EventBanner)`
  margin-bottom: 20px;
  width: 300px;
  height: 112px;
`;

const eventBanners = [
  {
    id: 26,
    name: 'There Comes the Future Star',
    image: '/event-images/there-comes-the-future-star.png',
    link: '/there-comes-the-future-star',
  },
  {
    id: 25,
    name: 'Scherzo of Iron and Blood',
    image: '/event-images/scherzo-of-iron-and-blood.png',
    link: '/scherzo-of-iron-and-blood',
  },
  {
    id: 24,
    name: 'Virtual Connection Synchronicity',
    image: '/event-images/virtual-connection-synchronicity.jpg',
    link: '/virtual-connection-synchronicity',
  },
  {
    id: 23,
    name: 'Operation Manjuu',
    image: '/event-images/operation-manjuu.jpg',
    link: '/operation-manjuu',
  },
  {
    id: 22,
    name: 'Ink-Stained Steel Sakura',
    image: '/event-images/ink-stained-steel-sakura.jpg',
    link: '/ink-stained-steel-sakura',
  },
  {
    id: 21,
    name: 'A Foreign Idol?',
    image: '/event-images/a-foreign-idol.png',
    disabled: true,
    link: '',
  },
  {
    id: 20,
    name: 'Visitors Dyed in Red Rerun?',
    image: '/event-images/visitors-dyed-in-red-rerun.png',
    link: '/visitors-dyed-in-red-rerun',
  },
  {
    id: 19,
    name: 'Moonlit Overture',
    image: '/event-images/moonlit-overture.png',
    disabled: true,
    link: '',
  },
  {
    id: 18,
    name: 'Winter\'s Crown',
    image: '/event-images/winters-crown.png',
    disabled: true,
    link: '',
  },
  {
    id: 17,
    name: 'The Solomon Ranger',
    image: '/event-images/the-solomon-ranger.png',
    disabled: true,
    link: '',
  },
  {
    id: 16,
    name: 'Flower Festival',
    image: '/event-images/flower-festival.png',
    disabled: true,
    link: '',
  },
  {
    id: 15,
    name: 'Lunar New Year 2019',
    image: '/event-images/lunar-new-year-2019.png',
    disabled: true,
    link: '',
  },
  {
    id: 14,
    name: 'The Pursuit of Graf Spee',
    image: '/event-images/the-pursuit-of-graf-spee.png',
    disabled: true,
    link: '',
  },
  {
    id: 13,
    name: 'Lunar New Year Celebration',
    image: '/event-images/lunar-new-year-celebration.png',
    disabled: true,
    link: '',
  },
  {
    id: 12,
    name: 'Crimson Echoes',
    image: '/event-images/crimson-echoes.png',
    disabled: true,
    link: '',
  },
  {
    id: 11,
    name: 'The Holy Night of Love and Peace',
    image: '/event-images/the-holy-night-of-love-and-peace.png',
    disabled: true,
    link: '',
  },
  {
    id: 10,
    name: 'Divergent Chessboard',
    image: '/event-images/divergent-chessboard.jpg',
    disabled: true,
    link: '',
  },
  {
    id: 9,
    name: 'Class Z-23 Sensei',
    image: '/event-images/class-z23-sensei.png',
    disabled: true,
    link: '',
  },
  {
    id: 8,
    name: 'Visitors from Another Dimension',
    image: '/event-images/visitors-from-another-dimension.png',
    disabled: true,
    link: '',
  },
  {
    id: 7,
    name: 'Witches\' Eve',
    image: '/event-images/witches-eve.png',
    disabled: true,
    link: '',
  },
  {
    id: 6,
    name: 'Lively Afternoon Tea Party',
    image: '/event-images/lively-afternoon-tea-party.png',
    disabled: true,
    link: '',
  },
  {
    id: 5,
    name: 'Fallen Wings',
    image: '/event-images/fallen-wings.png',
    disabled: true,
    link: '',
  },
  {
    id: 4,
    name: 'Stardust',
    image: '/event-images/stardust.png',
    disabled: true,
    link: '',
  },
  {
    id: 3,
    name: 'Visitors Dyed In Red',
    image: '/event-images/visitors-dyed-in-red.png',
    disabled: true,
    link: '',
  },
  {
    id: 2,
    name: 'Sea Star On Shore',
    image: '/event-images/sea-star-on-shore.png',
    disabled: true,
    link: '',
  },
  {
    id: 1,
    name: 'Strive, Wish and Strategize',
    image: '/event-images/strive-wish-and-strategize.png',
    disabled: true,
    link: '',
  },
];

const renderBanner = ({ id, image, name, disabled }) => (
  <StyledEventBanner
    key={id}
    src={image}
    alt={name}
    disabled={disabled}
  />
);

export default function EventList() {
  return (
    <EventsWrapper>
      {eventBanners.map(banner =>
        banner.disabled
          ? renderBanner(banner)
          : (
            <Link to={banner.link} key={banner.id}>
              {renderBanner(banner)}
            </Link>
          )
      )}
    </EventsWrapper>
  );
}
